import classnames from "classnames";

import { useStyles } from "./styles";
import tableIcon from "./../../images/table-icons.svg";
import backIcon from "./../../images/back-icon.svg";
import exchangeIcon from "./exchange.svg";
import { IconButton } from "@mui/material";

const TablePlaceholder = ({
    tableId,
    tableName,
    floorNumber,
    actions,
    reserved,
    icon,
}) => {
    const classes = useStyles();
    return (
        <div className={classes.TableDetails}>
            <div className="TableIcon">
                <img src={icon ? icon : tableIcon} />
            </div>
            <div className="TableName">
                <div>{tableName}</div>
                <div>{floorNumber}</div>
            </div>
            <div className="TableName">
                <div>{reserved ? "Reserved" : ""}</div>
            </div>
            <div className="Actions">
                {actions.map((entry) => {
                    return (
                        <button>
                            <i
                                className={classnames("bx", {
                                    "bxs-trash": entry.type == "delete",
                                })}
                                onClick={() => entry.onClick(tableId)}
                            ></i>
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

const SmallTablePlaceholder = ({
    tables,
    backCallback,
    internalMessage,
    icon,
}) => {
    const classes = useStyles();

    const handleBackCallback = () => {
        if (backCallback) {
            backCallback();
        }
    };

    return (
        <div className={classes.SmallTablePlaceholder}>
            {tables && tables.length > 0 && (
                <div className={classnames({ TwoTables: tables.length == 2 })}>
                    <div
                        className={classnames({ Table1: tables[0].canDoBack })}
                    >
                        {tables[0].canDoBack && (
                            <IconButton
                                onClick={() => handleBackCallback()}
                                className="BackBtn"
                            >
                                <img src={backIcon} />
                            </IconButton>
                        )}
                        <TablePlaceholder
                            tableId={tables[0].id}
                            tableName={tables[0].name}
                            floorNumber={tables[0].floor}
                            actions={tables[0].actions}
                            icon={icon}
                            reserved={tables[0].reserved}
                        />
                    </div>
                    {internalMessage && (
                        <div className={classes.TableDetails}>
                            {internalMessage}
                        </div>
                    )}
                    {tables[1] && (
                        <>
                            <div className={classes.ExchangeBtn}>
                                <img src={exchangeIcon} />
                            </div>
                            <TablePlaceholder
                                tableId={tables[1].id}
                                tableName={tables[1].name}
                                floorNumber={tables[1].floor}
                                actions={tables[1].actions}
                            />
                        </>
                    )}
                </div>
            )}
        </div>
    );
};

export default SmallTablePlaceholder;
